import { render, staticRenderFns } from "./user-personal.vue?vue&type=template&id=3fd62ec3"
import script from "./user-personal.vue?vue&type=script&lang=js"
export * from "./user-personal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports